import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";

/** Modules */
import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./components/auth/auth.module";
import { KwikspaceModule } from "./components/pwa/pwa.module";
import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared-modules/shared-modules.module";
import { RootStoreModule } from "./root-store";

/** Components */
import { AppComponent } from "./app.component";
import { ProfileIconMenuComponent } from "./core/components/profile-icon-menu/profile-icon-menu.component";

/** Services */
import { TokenService } from "./services/token.service";
import { TanToastrService } from "./services/toastr.service";
import { RoutingStateService } from './services/routing-state.service';
import { StaticDataService } from "./services/static-data.service";
import { PaginationService } from "./services/pagination.service";
import { FloorplannerService } from "./services/floorplanner.service";

/** Environment */
import { environment } from "../environments/environment";

@NgModule({
  declarations: [
    AppComponent,
    ProfileIconMenuComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KwikspaceModule.forRoot(),
    AuthModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    SharedModule,
    CoreModule,
    RootStoreModule,
    StoreDevtoolsModule.instrument({
      maxAge: 500, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
  ],
  providers: [
    TanToastrService,
    RoutingStateService,
    StaticDataService,
    PaginationService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenService, multi: true },
    FloorplannerService,
    { provide: Window, useValue: window }
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
